export type PartySlot = string | null;

export type PartyState = [PartySlot, PartySlot, PartySlot, PartySlot, PartySlot];

export function createInitialPartyState(): PartyState {
  return ["alice", "beatrice", "chloe", null, null];
}

export function countPartyMembers(party: PartyState): number {
  return party.filter((characterId) => characterId !== null).length;
}

export function assignPartyMember(party: PartyState, slotIndex: number, characterId: string): PartyState {
  assertSlotIndex(slotIndex);
  if (!characterId) throw new Error("A character id is required.");

  const next: PartyState = [...party];
  for (let index = 0; index < next.length; index += 1) {
    if (index !== slotIndex && next[index] === characterId) next[index] = null;
  }
  next[slotIndex] = characterId;
  return next;
}

export function removePartyMember(party: PartyState, slotIndex: number): PartyState {
  assertSlotIndex(slotIndex);
  const next: PartyState = [...party];
  next[slotIndex] = null;
  return next;
}

function assertSlotIndex(slotIndex: number): void {
  if (!Number.isInteger(slotIndex) || slotIndex < 0 || slotIndex >= 5) {
    throw new Error("Party slot index must be between 0 and 4.");
  }
}
